const bottomOfset = 200;
export default bottomOfset;
